/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:28:35
 * @FilePath: \mrc-base-frontend\src\service\api\pushMessageTopic.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 10:09:22
 */
// 消息主题
import http from "../httpConfig";

const table = "mrbase_sys_message_push_topic";
const table2 = "mrbase_sys_message_push_map_user_and_topic";

// 获取主题列表
export const getMessageTopicList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-topic-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取主题详情
export const getMessageTopicDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-topic/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 主题新增
export const addMessageTopicDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/add-topic/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Message主题修改
export const updateMessageTopicDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/update-topic/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Message主题删除
export const deleteMessageTopicDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/delete-topic/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//员工关系
export const getMessageTopicMap = (params = {}) => {
  params["~table~"] = table2;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-topic-map/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//删除员工关系
export const deleteMessageTopicMap = (params = {}) => {
  params["~table~"] = table2;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/delete-topic-map/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
